import { createApp } from "vue";
import GeneralDataComponent from "./GeneralDataComponent";

const app = createApp({
  components: {
    "general-data-component": GeneralDataComponent,
  },
}).mount("#container-general-data");
